import { render, staticRenderFns } from "./home_renovation.vue?vue&type=template&id=5b933f91&scoped=true"
import script from "./home_renovation.vue?vue&type=script&lang=js"
export * from "./home_renovation.vue?vue&type=script&lang=js"
import style0 from "./home_renovation.vue?vue&type=style&index=0&id=5b933f91&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b933f91",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b933f91')) {
      api.createRecord('5b933f91', component.options)
    } else {
      api.reload('5b933f91', component.options)
    }
    module.hot.accept("./home_renovation.vue?vue&type=template&id=5b933f91&scoped=true", function () {
      api.rerender('5b933f91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/appNewRenovation/home/home_renovation.vue"
export default component.exports